import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dc",
  "use": "icon-dc-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-dc\">\r\n  <defs>\r\n    <style>\r\n      #icon-dc .cls-1 {\r\n        fill: #606266;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-dc_数据\" class=\"cls-1\" d=\"M388.017,565a9.01,9.01,0,0,1-.663-18,0.476,0.476,0,0,1,.511.475v8.755h8.656a0.476,0.476,0,0,1,.475.516A9.064,9.064,0,0,1,388.017,565ZM386.912,548a8.058,8.058,0,1,0,9.074,9.179h-8.6a0.476,0.476,0,0,1-.476-0.477V548Zm9.4,6.454H389.99a0.477,0.477,0,0,1-.477-0.477v-6.3a0.477,0.477,0,0,1,.587-0.463,9.074,9.074,0,0,1,6.676,6.652A0.478,0.478,0,0,1,396.312,554.457Zm-5.846-.953h5.217a8.135,8.135,0,0,0-5.217-5.2v5.2Z\" transform=\"translate(-379 -547)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dc.svg
// module id = zY2Z
// module chunks = 127